import { ShareSettings } from "../models/sharesettin";

export class UploadShareData {
    type: string = "";
    types: string = "";
    location: string = ""
    id: number = 0;
    name: string = "";
    size: string = "";
    lastmodified: string = "";
    foldertype:string=""
    shareSettings: ShareSettings = new ShareSettings();
}